import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ObtenerNumeroUsuariosService } from '../../../../domain/administrador/dashboard/obtener-numero-usuarios.service';
import { ObtenerNumeroGruposService } from '../../../../application/administrador/services/obtener-numero-grupos.service';
import { ObtenerNumeroPerfilesService } from '../../../../application/administrador/services/obtener-numero-perfiles.service';
import { Observable, zip } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-widget-resumen-usuarios',
  templateUrl: './widget-resumen-usuarios.component.html',
  styleUrl: './widget-resumen-usuarios.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WidgetResumenUsuariosComponent implements OnInit {
  numeroUsuarios: number = 0;
  numeroGrupos: number = 0;
  numeroPerfiles: number = 0;
  cargando: boolean = true;

  constructor(
    private readonly obtenerNumeroUsuariosService: ObtenerNumeroUsuariosService,
    private readonly obtenerNumeroGruposService: ObtenerNumeroGruposService,
    private readonly obtenerNumeroPerfilesService: ObtenerNumeroPerfilesService,
    private toastrService: ToastrService,
  ) {}

  ngOnInit() {
    zip(
      this.obtenerNumeroUsuarios(),
      this.obtenerNumeroGrupos(),
      this.obtenerNumeroPerfiles(),
    ).subscribe({
      next: ([usuarios, grupos, perfiles]) => {
        this.numeroUsuarios = usuarios;
        this.numeroGrupos = grupos;
        this.numeroPerfiles = perfiles;
      },
      error: (error) => {
        this.toastrService.error(
          'Error al cargar la información sobre los usuarios',
        );
        this.cargando = false;
      },
      complete: () => {
        this.cargando = false;
      },
    });
  }
  public obtenerNumeroUsuarios(): Observable<number> {
    return this.obtenerNumeroUsuariosService.__invoke();
  }

  public obtenerNumeroGrupos(): Observable<number> {
    return this.obtenerNumeroGruposService.__invoke();
  }

  public obtenerNumeroPerfiles(): Observable<number> {
    return this.obtenerNumeroPerfilesService.__invoke();
  }
}
